// src/signalr/SignalRService.ts
import * as signalR from '@microsoft/signalr';
import { SignalRServiceBase } from './SignalRTypes';
import { useEffect, useState } from 'react';

type SignalRServiceV1Props = {
    url: string;
}


export const useSignalRServiceV1 = (props: SignalRServiceV1Props) => {
    const [connection, setConnection] = useState<signalR.HubConnection | undefined>(undefined);
    const [connectState, setConnectState] = useState<boolean>(false);
    const [url, setUrl] = useState<string>(props.url);

    useEffect(() => {
        setUrl(props.url)
    }, [props.url])

    useEffect(() => {
        if (url) {
            if (window.jQuery) {
                console.log('jQuery version:', window.jQuery.fn.jquery);
            } else {
                window.jQuery = window.$;
                console.error('jQuery is not loaded');
            }
            init();
        }
    }, [url])

    useEffect(() => {
        if (connection) connect();
    }, [connection])

    const init = async () => {
        if (localStorage.getItem("defaultApiVersion") === "dotNet6" || localStorage.getItem("defaultApiVersion") === "dotNet6_AM_N")
            await setConnectionOptions();
    }

    const setConnectionOptions = async () => {
        let c = new signalR.HubConnectionBuilder()
            .withUrl(url)
            .withAutomaticReconnect([0, 3000, 5000, 10000])
            // 多久沒有收到server訊息會判定現在斷線了
            .withServerTimeout(1000 * 60)
            // 方法設定客戶端發送心跳消息的間隔，這是為了確保連接是活躍的並維持與伺服器的連接。這個設定有助於避免由於網絡閒置導致的連接超時斷開。心跳消息是小型的、定期發送的信號，確保連接在網絡上保持活躍狀態。
            .withKeepAliveInterval(10000)
            // 啟用有狀態的自動重連
            .withStatefulReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();

        c.onreconnecting(error => {
            console.log('signalR: Reconnecting... ❌', error);
            setConnectState(false);
        });

        c.onreconnected(connectionId => {
            console.log('signalR: Reconnected successfully ✅', connectionId);
            setConnectState(true);
        });

        c.onclose(connectionId => {
            console.log('signalR: onclose', connectionId);
            setConnectState(false);
        });

        setConnection(c);
    }
    const connect = async () => {
        if (connection)
            await connection
                .start()
                .then(() => {
                    console.log('signalR: Connected');
                    setConnectState(true);
                })
                .catch(err => console.error('SignalR Connection Error: ', err));
        else console.error("SignalR v1 遺失connection 物件");
    }

    return { connection, connectState };
}